import api from "../services/api";

const service_path = '/dashboard.php';

export function getDashboard(filters = {}) {
    const cleanFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value !== '' && value !== null && value !== undefined) {
            acc[key] = value;
        }
        return acc;
    }, {});

    const params = new URLSearchParams(cleanFilters).toString();
    const url = params ? `${service_path}?${params}` : service_path;

    return api.get(url);
};
